export default "__VITE_ASSET__Bqdl6P6E__"